import React, { useEffect } from "react";
import { mount } from "globalNavigationReact/index";

const Footer = (props) => {
  let locale = props.locale;
  if (!locale) {
    return null;
  }
  useEffect(() => {
    mount({
      //TODO: replace current header with the header from the global-navigation-react project
      //headerElemID: "consent-header-container",
      showHeader: false,
      footerElemID: "consent-footer-container",
      showFooter: true,
      //headerConfig: { preventPullUp: true },
      footerConfig: {
        showLegalFooter: true,
        showPageFooter: false,
      },
      mountLocale: locale,
      mountBrand: "preferences",
      injectAEMfont: false,
      APIEndpoint: NVIDIA_NAVBAR_FOOTER_SERVICE_PATH,
    });
  }, []);
  return <div id="consent-footer-container"></div>;
};

export default Footer;
